import {
  FETCH_RENAME_TEMPLATE_REQUEST,
  FETCH_RENAME_TEMPLATE_SUCCESS,
  FETCH_RENAME_TEMPLATE_FALUIRE,
} from './renameTemplateTypes'

const initialState = {
  loading: false,
  renameTemplateInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_RENAME_TEMPLATE_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_RENAME_TEMPLATE_SUCCESS : return {
      ...state,
      renameTemplateInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_RENAME_TEMPLATE_FALUIRE : return {
      ...state,
      loading: false,
      renameTemplateInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
